import { downloadInNewTab } from "@yiban-shared/utils";

const thead = [
  "报名形式",
  "学校名称",
  "个人/团体",
  "个人姓名/团队成员",
  "作品类型",
  "作品名称",
  "操作",
];
const rowActionConfig = [
  {
    text: "查看",
    handler: ({ downloadUrl }) => downloadInNewTab(downloadUrl),
  },
  {
    type: "delete",
    text: "删除",
    message: "确认%text作品【%s】吗？",
    messagePlaceholder: "title",
  },
];

export default {
  data() {
    return {
      thead,
      rowActionConfig,
    };
  },
};
